import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { selectNotificationsState } from '@app/core/store/reducers/notifications.reducer';
import { Notification } from '@core/models/notification/notification';
import { AppState } from '@core/store/reducers';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-notifications',
  template: `
    <div *ngIf="notifications && notifications.length > 0">
      <app-notification [notification]="notification" [extraCss]="extraCss" *ngFor="let notification of notifications"></app-notification>
    </div>
  `
})
export class NotificationsComponent implements OnInit, OnDestroy {

  @Input()
  target: string;

  @Input()
  extraCss: string;

  notifications: Notification[] = [];
  subscription: Subscription;

  constructor(private store: Store<AppState>) { }

  ngOnInit(): void {
    this.subscription = this.store.select(selectNotificationsState).subscribe((state) => {
      this.notifications = state?.filter((notification) => {
        return notification.target === this.target;
      });
    });
  }

  ngOnDestroy(): void {
    if (this.subscription )this.subscription.unsubscribe();
  }
}
